import TooltipBox from './TooltipBox';
import { Stack, useTheme } from '@mui/system';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { convertEbabPeriod } from '../../functions/charts';

/**
 * Renders a tooltip element with absolute positioning, used to display additional information
 * for the BA score over time chart.
 * Displays the full EBAB period, BA score and peer group median score for the relevant quarter.
 * @component
 * @param {Object} position - absolute x and y screen coordinates where the tooltip is to be rendered
 * @param {Object} scoreData - data to display in tooltip
 * @returns {React.ReactElement} - rendered tooltip component
 */
export const ScoreOverTimeTooltip = ({ position, scoreData }) => {
    const theme = useTheme();

    return (
        <TooltipBox
            sx={{
                top: position.y,
                left: position.x,
                width: theme.sizing.tooltip.overTime.width,
                padding: '1rem'
            }}
        >
            <Stack spacing={1}>
                <Typography variant={'body2'} sx={{ fontWeight: 500 }}>
                    {convertEbabPeriod(scoreData.ebabPeriod, true)}
                </Typography>
                <Stack>
                    <Stack direction='row' justifyContent='space-between'>
                        <Typography variant={'body2'}>BA Score</Typography>
                        <Typography variant={'body2'}>
                            {scoreData.baScore?.toFixed(1)}
                        </Typography>
                    </Stack>
                    <Stack direction='row' justifyContent='space-between'>
                        <Typography variant={'body2'}>Median</Typography>
                        <Typography variant={'body2'}>
                            {scoreData.peerGroupMetrics.medianBaScore?.toFixed(
                                1
                            )}
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>
        </TooltipBox>
    );
};

ScoreOverTimeTooltip.propTypes = {
    scoreData: PropTypes.any,
    position: PropTypes.shape({ x: PropTypes.any, y: PropTypes.any })
};
